if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.bundle_addto_cart = this.form.querySelectorAll('.bundleKitATC');
        if(this.bundle_addto_cart) {
          this.bundle_addto_cart.forEach(addToCartItem => {
            addToCartItem.addEventListener('click', this.onKitHandler.bind(this));
          })
          
        }
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if(this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
          
        }
      
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onKitHandler(evt) {
        evt.preventDefault();
        console.log('atc trigger');
        const productRecommeneded = evt.target.classList.contains('recommended-btn')
        // return;
        // Generate a random unique ID for this bundle instance
        // const uniqueId = 'bundle-' + Date.now() + '-' + Math.floor(Math.random() * 10000);
        const uniqueId = 'bundle-1749622740086-7873';
        const mainProductHandle = window.mainProduct;
        const discountcode = window.discountcode;
        const products = window.bundleProducts || [];
        const quantity = document.querySelector('.quantity__input [name=quantity]') != null ? document.querySelector('.quantity__input [name=quantity]').value : 1;
        let properties = {
          "_bundle_items": true,
          "_unique_id": uniqueId,
          "_bundle_code": `${uniqueId}-1`,
          "_bundle_product": mainProductHandle
        };
        let hasAppliedCoupon = document.getElementById('applyCoupon') != null ? document.getElementById('applyCoupon').checked : false

        if (hasAppliedCoupon) {
          properties = {
            "_bundle_items": true,
            "_unique_id": uniqueId,
            "_bundle_code": `${uniqueId}-1`,
            "_bundle_product": mainProductHandle
          };
        }
        
        const items = {
          id: 45425553244359,
          quantity: quantity,
          properties: properties
        }
        let formData = {
          'items': [{
            'id': window.bundleFreeItem,
            'quantity': quantity,
            'properties': properties
          }],
          'sections': this.cart.getSectionsToRender().map((section) => section.id)
        };

        // Is is not used and causing issue if recommended product is added
        if (hasAppliedCoupon || productRecommeneded) {
          const url = `/discount/${discountcode}`;
          fetch(url);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then(response => response.json())
          .then(response => {
            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(response);
          });
            // console.log('Items added to cart:', cart);
            // if (document.getElementById('applyCoupon').checked) {
            //   if(discountcode != '') {
            //     window.location.href = `https://peepclub.com/discount/${discountcode}?redirect=/cart`
            //   } else {
            //     window.location.href = '/cart';  
            //   }              
            // } else {
            //   window.location.href = '/cart';
            // }
          })
          .catch(error => console.error('Error adding items:', error))
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            // this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log('evt============>', evt)
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
